import { useEffect } from 'react';

import Navbar from "./Navbar";
import QuestionText from "./Question_Text";
import QuestionSelect from "./Question_Select";
import QuestionUpload from "./Question_Upload";
import QuestionMandatSEPA from "./Question_MandatSEPA";
import QuestionTextarea from "./Question_Textarea";
import QuestionAutre from "./Question_Autre";
import QuestionPaiement from "./Question_Paiement";
import QuestionSearchC from "./Question_Search"
import React, { useRef, useState } from 'react';
const { buildQuestionLookup, isQuestionVisible } = require("../shared/progress");

export default function HomeSousCritere({ souscritereInfo, getMainActifNum, setMainActifNum, getNumberFiliereActif, getNumberCritereActif, setNumberCritereActif, getNumberSousCritereActif, setNumberSousCritereActif, criteres, updateQuestionValue, updateQuestionVue, updateQuestionSearchCode, updateQuestionSelectPays, updateQuestionSearchValueName, etudiant, data, filiere, estimationTestSelection, setEstimationTestSelection, isEstimationTestWindowOpen, disabledBoutonSoumission, Lang, setQuestionValueToTrue, isDisabled2, checkPaymentExists, paymentExists, updateQuestionVisible, updateFiltreGeneral, sendDataToServer, triggerSave, recordNav }) {



    /* ------------------------------------------------------------ STATE ------------------------------------------------------------ */

    // updateQuestionVue(getNumberCritereActif, getNumberSousCritereActif);


    const [isDisabled, setIsDisabled] = useState(false);
    const scrollRef = useRef(null);

    let prochainCritereId;

    useEffect(() => {
        // Vérifie que les index sont valides avant d'appeler updateQuestionVue
        if (
            typeof getNumberCritereActif === "number" &&
            typeof getNumberSousCritereActif === "number"
        ) {
            updateQuestionVue(getNumberCritereActif, getNumberSousCritereActif);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getNumberCritereActif, getNumberSousCritereActif]);

    try {
        prochainCritereId = criteres[getNumberCritereActif + 1].id;
    } catch {
        prochainCritereId = 51;
    }


    /* ------------------------------------------------------------ COMPORTEMENT ------------------------------------------------------------ */



    /* --- MISE EN ÉVIDENCE DES CHAMPS OBLIGATOIRES AVEC UN * --- */
    const mettreEnEvidenceAsterisques = () => {
        setTimeout(() => {
            document.querySelectorAll('label').forEach(function (label) {
                if (label.textContent.includes('*')) {
                    label.innerHTML = label.innerHTML.replace('*', '<span style="color: #ef7c7a; font-size: calc(1vw + 1.5vh);">*</span>');
                }
            });
            document.querySelectorAll('vue').forEach(function (vue) {
                if (vue.textContent.includes('true')) {
                    vue.innerHTML = vue.innerHTML.replace('*', '<span style="color: #ef7c7a; font-size: calc(1vw + 1.5vh);">*</span>');
                }
            });
        }, 0);
    };

    // Premier appel en cas de chargement de page
    mettreEnEvidenceAsterisques();

    // Utilisation de useEffect pour détecter si le sous-critères affiché change (charge les * à chaque changement de page)
    useEffect(() => {
        // Appeler la fonction pour mettre en évidence les astérisques
        mettreEnEvidenceAsterisques();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getNumberSousCritereActif, getNumberCritereActif]);


    /* --- GESTION DE LA SCROLL BAR ET DE LA DÉSACTIVATION TEMPORAIRE DES BOUTONS (300ms) À CHAQUE CHANGEMENT DE SOUS-CRITÈRE --- */


    const handleScrollToTop = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
        setIsDisabled(true);
        setTimeout(() => {
            setIsDisabled(false);
        }, 500);
    };
    try {
    } catch {

    }

    const currentPeriod = data?.data?.[getNumberFiliereActif];
    const questionLookup = buildQuestionLookup(currentPeriod);

    /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */



    if (data?.configuration === 'Echange' && Number(currentPeriod?.criteres?.[getNumberCritereActif]?.id) === 50) {
        return <p>{Lang === 'en' ? 'Submission is not available yet.' : 'L’envoi du dossier n’est pas encore ouvert.'}</p>;
    }

    return (
        <>
            <div className="HomeSousCritereMenuFondBlanc">
                {/*Zone à l'intérieur du rectangle blanc et ayant la hauteur de la bar de scroll*/}
                <div className="HomeSousCritereMenu" ref={scrollRef}>
                    {data && data.data && data.data[getNumberFiliereActif] && data.data[getNumberFiliereActif].criteres && data.data[getNumberFiliereActif].criteres[getNumberCritereActif] && data.data[getNumberFiliereActif].criteres[getNumberCritereActif].sousCriteres && data.data[getNumberFiliereActif].criteres[getNumberCritereActif].sousCriteres[getNumberSousCritereActif] ?
                        (
                            <h2> - {data.data[getNumberFiliereActif].criteres[getNumberCritereActif].sousCriteres[getNumberSousCritereActif].nom}</h2>
                        ) : (
                            <h2>Loading...</h2>
                        )
                    }
                    <div className="HomeSousCritereMenuMain">
                        {data?.data?.[getNumberFiliereActif]?.criteres?.[getNumberCritereActif]?.sousCriteres?.[getNumberSousCritereActif]?.Help ? (
                            <h3>{data.data[getNumberFiliereActif].criteres[getNumberCritereActif].sousCriteres[getNumberSousCritereActif].Help}</h3>
                        ) : null}

                        {souscritereInfo.map((question, questionIndex) => (
                            !isQuestionVisible(question, {
                                dataFiltres: currentPeriod?.filtres,
                                questionLookup
                            }) ? null : question.type === "select" ? (
                                <QuestionSelect
                                    key={question.id}
                                    questionInfo={question}
                                    getNumberFiliereActif={getNumberFiliereActif}
                                    getNumberCritereActif={getNumberCritereActif}
                                    updateQuestionValue={updateQuestionValue}
                                    updateQuestionVisible={updateQuestionVisible}
                                    updateQuestionSelectPays={updateQuestionSelectPays}
                                    updateFiltreGeneral={updateFiltreGeneral}
                                    sendDataToServer={sendDataToServer}
                                    paymentExists={paymentExists}
                                    sousCritereIndex={getNumberSousCritereActif}
                                    souscritereInfo={souscritereInfo}
                                    questionIndex={questionIndex}
                                    data={data}
                                />
                            ) : question.type === "search" ? (
                                <QuestionSearchC
                                    key={question.id}
                                    questionInfo={question}
                                    getNumberFiliereActif={getNumberFiliereActif}
                                    getNumberCritereActif={getNumberCritereActif}
                                    updateQuestionValue={updateQuestionValue}
                                    updateQuestionSearchCode={updateQuestionSearchCode}
                                    updateQuestionSearchValueName={updateQuestionSearchValueName}
                                    updateQuestionVue={updateQuestionVue}
                                    sousCritereIndex={getNumberSousCritereActif}
                                    souscritereInfo={souscritereInfo}
                                    questionIndex={questionIndex}
                                    data={data}
                                />
                            ) : question.type === "file" ? (
                                question.nom === "MandatSEPA" ? (
                                    <QuestionMandatSEPA
                                        key={question.id}
                                        questionInfo={question}
                                        getNumberFiliereActif={getNumberFiliereActif}
                                        getNumberCritereActif={getNumberCritereActif}
                                        etudiant={etudiant}
                                        updateQuestionValue={updateQuestionValue}
                                        sousCritereIndex={getNumberSousCritereActif}
                                        souscritereInfo={souscritereInfo}
                                        questionIndex={questionIndex}
                                        data={data}
                                        Lang={Lang}
                                        setQuestionValueToTrue={setQuestionValueToTrue}
                                    />
                                ) : (
                                    <QuestionUpload
                                        key={question.id}
                                        questionInfo={question}
                                        getNumberFiliereActif={getNumberFiliereActif}
                                        getNumberCritereActif={getNumberCritereActif}
                                        etudiant={etudiant}
                                        updateQuestionValue={updateQuestionValue}
                                        sousCritereIndex={getNumberSousCritereActif}
                                        souscritereInfo={souscritereInfo}
                                        questionIndex={questionIndex}
                                        data={data}
                                        Lang={Lang}
                                        setQuestionValueToTrue={setQuestionValueToTrue}
                                    />
                                )
                            ) : question.type === "textarea" ? (
                                <QuestionTextarea
                                    key={question.id}
                                    questionInfo={question}
                                    etudiant={etudiant}
                                    updateQuestionValue={updateQuestionValue}
                                    sousCritereIndex={getNumberSousCritereActif}
                                    souscritereInfo={souscritereInfo}
                                    questionIndex={questionIndex}
                                />
                            ) : question.type === "paiement" ? (
                                <QuestionPaiement
                                    key={question.id}
                                    questionInfo={question}
                                    getNumberFiliereActif={getNumberFiliereActif}
                                    getNumberCritereActif={getNumberCritereActif}
                                    sousCritereIndex={getNumberSousCritereActif}
                                    souscritereInfo={souscritereInfo}
                                    questionIndex={questionIndex}
                                    data={data}
                                    Lang={Lang}
                                    updateQuestionValue={updateQuestionValue}
                                    checkPaymentExists={checkPaymentExists}
                                    paymentExists={paymentExists}
                                />
                            ) : question.type === "autre" ? (
                                <QuestionAutre
                                    key={question.id}
                                    questionInfo={question}
                                    questionIndex={questionIndex}
                                    data={data}
                                    getNumberFiliereActif={getNumberFiliereActif}
                                    getNumberCritereActif={getNumberCritereActif}
                                    souscritereInfo={souscritereInfo}
                                    sousCritereIndex={getNumberSousCritereActif}

                                />
                            ) : (
                                <QuestionText
                                    key={question.id}
                                    questionInfo={question}
                                    getNumberFiliereActif={getNumberFiliereActif}
                                    getNumberCritereActif={getNumberCritereActif}
                                    updateQuestionValue={updateQuestionValue}
                                    updateQuestionVue={updateQuestionVue}
                                    sousCritereIndex={getNumberSousCritereActif}
                                    souscritereInfo={souscritereInfo}
                                    questionIndex={questionIndex}
                                    data={data}
                                    filiere={filiere}
                                    estimationTestSelection={estimationTestSelection}
                                    setEstimationTestSelection={setEstimationTestSelection}
                                    isEstimationTestWindowOpen={isEstimationTestWindowOpen}
                                />
                            )
                        ))}
                    </div>
                </div>
            </div>

            {/*Navbar en bas de la page*/}
            {(prochainCritereId !== 51) && (

                <div className="HomeSousCritereNavbar">
                    <Navbar
                        getMainActifNum={getMainActifNum}
                        setMainActifNum={setMainActifNum}
                        getNumberFiliereActif={getNumberFiliereActif}
                        getNumberCritereActif={getNumberCritereActif}
                        setNumberCritereActif={setNumberCritereActif}
                        getNumberSousCritereActif={getNumberSousCritereActif}
                        setNumberSousCritereActif={setNumberSousCritereActif}
                        criteres={criteres}
                        click={handleScrollToTop}
                        data={data}
                        isDisabled={isDisabled}
                        isDisabled2={isDisabled2}
                        disabledBoutonSoumission={disabledBoutonSoumission}
                        Lang={Lang}
                        triggerSave={triggerSave}
                        recordNav={recordNav}
                    />
                </div>
            )}
        </>
    );

}
